import { IconCopy } from "@/assets/icons/IconCopy";
import { Copyable } from "@/components/elements/Copyable";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export type TRecordItem = {
  key: string;
  value: string;
  copyable?: boolean;
};

export type TRecordListProps = {
  data: TRecordItem[];
};

export const RecordList: FC<TRecordListProps> = ({ data }) => {
  return (
    <Stack gap="4px">
      {data.map(({ key, value, copyable }) => (
        <Stack key={key} direction="row" gap={1} alignItems="start" color={text.secondary}>
          <Typography variant="sub16Semi" whiteSpace="nowrap">
            {key} :
          </Typography>
          <Stack direction="row" gap={1} alignItems="center" flex={1}>
            <Typography variant="sub16Semi" style={{ wordBreak: "break-all" }}>
              {value}
            </Typography>
            {copyable && (
              <Copyable text={value}>
                <IconCopy fontSize={24} />
              </Copyable>
            )}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
